var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconViagem = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 40 40",
  style: {
    enableBackground: "new 0 0 40 40"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M39,4.4c-0.9-1.1-2-1.7-3.5-1.8c-1.4-0.1-2.7,0.3-3.9,1.3l-6.8,5.4c-0.5,0.4-1.3,0.5-1.8,0.2L11.5,4 C11,3.8,10.2,3.9,9.7,4.2L5.7,7.4c-0.5,0.4-0.5,1,0,1.4l8.6,7.4c0.4,0.4,0.5,1,0,1.4l-4.5,4.4c-0.4,0.4-1.2,0.6-1.8,0.4l-2.5-1 c-0.5-0.2-1.4-0.1-1.8,0.3l-3.4,2.6c-0.5,0.4-0.5,1,0,1.3l4.9,4c0.5,0.4,1,1.1,1.3,1.6l2.7,5.7c0.3,0.5,0.8,0.7,1.3,0.3l3.4-2.6 c0.5-0.4,0.8-1.1,0.7-1.7l-0.2-2.4c-0.1-0.6,0.3-1.3,0.8-1.7l5.1-3.5c0.5-0.3,1.1-0.2,1.4,0.3l5.1,10.1c0.3,0.5,0.9,0.7,1.3,0.3 l4.1-3.2c0.5-0.4,0.7-1.1,0.6-1.7l-2.6-12.4c-0.1-0.6,0.2-1.3,0.6-1.7l6-4.7c0.5-0.4,1.2-1,1.6-1.4c0,0,1.2-1.3,1.4-2.7 C40.2,6.7,39.9,5.5,39,4.4z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconViagem, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_viagem.d66ed805.svg";
export { ForwardRef as ReactComponent };